import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faFacebookF,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import './Header.scss';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import contactInfo from '../contact-info.json';

export function Header() {
  return (
    <header className="app-header header-desktop">
      <div className="socials">
        <a href={contactInfo.instagram}>
          <FontAwesomeIcon icon={faInstagram as IconProp} />
        </a>
        <a href={contactInfo.facebook}>
          <FontAwesomeIcon icon={faFacebookF as IconProp} />
        </a>
        <a href={contactInfo.linkedin}>
          <FontAwesomeIcon icon={faLinkedin as IconProp} />
        </a>
      </div>

      <h1 className="lato-thin m-0">LILIA FACIALISTE</h1>
      <p className="lato-thin m-0">Paris</p>
      <nav>
        <a href="#prestations">Prestations</a>
        <a href="#about">A propos</a>
        <a href="#contact">Contact</a>
      </nav>
    </header>
  );
}
